module.exports = __webpack_public_path__ + "img/LiteratureDB.bb022a29.jpeg";